import { lazy } from "react";
export const SummarizationAsync = lazy(()=>import("./SummarizationPage"))